import * as r from 'ramda';

export function tabTitleIndexing(tabs) {
    let used = {};
    let totals = r.countBy((key) => key)(tabs.map((tab) => tab.title));
    return function (tab) {
        used[tab.title] = used[tab.title] ? used[tab.title] + 1 : 1;
        return totals[tab.title] > 1 ? used[tab.title] : '';
    };
}
